module.exports = __webpack_public_path__ + "img/banner01.4ab20b59.png";